/* System defined core library */
import { Component, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { DateTimeService } from '../../../shared/services/date-time.service';
import { RoutingService } from '../../../shared/services/routing.service';
import { UtilityService } from '../../../shared/services/utility.service';
import { SelectedExamDetailService } from '../../shared/services/selected-exam-detail.service';

/* User defined models */
import { Timezone } from '../../../shared/models/scheduling/timezone.model';

/* User defined enums/constants */
import { ComponentType } from '../../../shared/enums/scheduling.enum';
import { CaptchaComponent } from '../../../shared/components/captcha/captcha.component';
import { BootstrapParams } from '../../../../bootstrap-params';


@Component({
  selector: 'app-schedule-timezone',
  templateUrl: './schedule-timezone.component.html',
  styleUrls: ['./schedule-timezone.component.scss'],
})
/** schedule-timezone component*/
export class ScheduleTimezoneComponent implements OnInit {
  /* User defined private/public variables */
  public correctTimezone: boolean = false;
  public currentTimezone: string = '';
  public userCaptchaInput: string = '';
  public captchaEnable: boolean;

  /* Input-Output parameters declarations */
  @Output() selectedTimezone: Timezone;

  /* Service subscriptions */
  timezone$: Subscription;

  @ViewChild(CaptchaComponent) captchaInstance: CaptchaComponent;

  /* Constructor declaration with required injected services */
  constructor(
    private dateTimeService: DateTimeService,
    private routingService: RoutingService,
    private selectedExamDetailService: SelectedExamDetailService,
    private utilityService: UtilityService,
    private bootstrapParams: BootstrapParams
  ) {

    // default timezone
    this.currentTimezone = this.dateTimeService.getBrowserTimeZone();

    this.timezone$ = this.selectedExamDetailService.timezone.subscribe(timezone => {
      if (timezone != null) {
        this.currentTimezone = timezone.systemName;
        this.selectedTimezone = timezone;
      }
    });

    this.selectedExamDetailService.getUserCaptchaInput().subscribe(captcha => {
        this.userCaptchaInput = captcha;
    });

    this.captchaEnable = this.bootstrapParams.captchaEnable;
  }

  /* Initialize the component & call required methods when component loaded first time. */
  ngOnInit() {
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.ScheduleTimezoneComponent)) return;
  }

  /* Move back a page */
  goToPrevPage(): void {
    this.routingService.backwardNavigation(ComponentType.ScheduleTimezoneComponent);
  }

  /* Move to next page */
  submit(): void {
    if(this.bootstrapParams.captchaEnable) {
      this.captchaInstance.validateCaptcha();
      this.selectedExamDetailService.getCaptchaValidationResult().subscribe(isCaptchaValid => {
        if (isCaptchaValid) {
          this.selectedExamDetailService.setTimeZone(this.selectedTimezone);
          this.routingService.scheduleFwdNavigation(ComponentType.ScheduleTimezoneComponent);
        }
      });
    }
    else {
        this.selectedExamDetailService.setTimeZone(this.selectedTimezone);
        this.routingService.scheduleFwdNavigation(ComponentType.ScheduleTimezoneComponent);
    }
  }

  /* Sets timezone based on user selection */
  setSingleTimezone(timezone: Timezone) {
    if (timezone != null && timezone != undefined) {
      this.selectedTimezone = timezone;
    } else {
      this.selectedTimezone = null;
    }
  }

  checkTimezone(e: any) {
    this.correctTimezone = e.target.checked;
  }

  /* disable next button on the basis of local variable value */
  isDisable(): boolean {
    return !this.correctTimezone || (this.selectedTimezone === null) || (this.userCaptchaInput == '' && this.bootstrapParams.captchaEnable);
  }
}
